import React, { useTransition } from "react";
import * as z from "zod";

import { Form, Input, DatePicker, Select, Button, Spin } from "antd";
import axios from "axios";
import { toast } from "sonner";
import dayjs from "dayjs";

import "./style.css";
import { useState } from "react";
import { ChevronLeft } from "lucide-react";

const PhoneSchema = z
  .string({
    error: (issue) =>
      issue.input === undefined && "Vui lòng nhập số điện thoại",
  })
  .regex(
    /(03|05|07|08|09|01[2|6|8|9])+([0-9]{8})\b/,
    "Số điện thoại di động không hợp lệ",
  );

export const RegisterForm = ({ faceId, avatar, onOk, onCancel }) => {
  const [form] = Form.useForm();

  const [isPending, startTransition] = useTransition();

  const [isPendingGetPhoneDetail, startTransitionGetPhoneDetail] =
    useTransition();

  const [phoneDetail, setPhoneDetail] = useState(null);

  const onGetPhoneDetailHandler = (value) => {
    form.setFieldsValue({
      fullName: "",
      email: "",
      gender: null,
      dob: null,
    });

    startTransitionGetPhoneDetail(async () => {
      try {
        if (PhoneSchema.safeParse(value).success) {
          const responsePhone = await axios.get(
            `${
              import.meta.env.VITE_API_BOOKING
            }/api/user/detail?phone=${value}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              },
            },
          );

          if (responsePhone.data) {
            setPhoneDetail(responsePhone.data);
            form.setFieldsValue({
              fullName: responsePhone.data.fullName,
              email: responsePhone.data.email,
              gender: responsePhone.data.gender,
              dob: responsePhone.data.dob
                ? dayjs(responsePhone.data.dob)
                : null,
            });
          } else {
            setPhoneDetail({});
          }
        }
      } catch (err) {
        if (err.response.status === 401) {
          toast.error("Hết thời gian đăng nhập vui lòng đăng nhập lại.");
          localStorage.removeItem("accessToken");
          window.location.reload();
          return;
        }
        console.log(err);
        toast.error(err?.response?.data?.error);
      }
    });
  };

  const onRegisterHandler = (values) => {
    startTransition(async () => {
      try {
        await axios.post(
          `${import.meta.env.VITE_API_BOOKING}/api/user/register/his`,
          {
            phone: values.phone,
            fullName: values.fullName,
            gender: values?.gender,
            email: values.email,
            faceIds: faceId ? [faceId] : null,
            dob: values.dob ? values.dob.toISOString() : null,
            avatar: avatar ?? null,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          },
        );

        const responseUpdateInfoAI = await axios.put(
          `${import.meta.env.VITE_API_URL}/api/faces/${faceId}`,
          {
            phone: values.phone,
            fullName: values.fullName,
            gender: values?.gender,
            email: values.email,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        if (responseUpdateInfoAI.data) {
          toast.success("Cập nhật thông tin tài khoản thành công");
          onOk({ faceId });
        }
      } catch (err) {
        if (error.response.status === 401) {
          toast.error("Hết thời gian đăng nhập vui lòng đăng nhập lại.");
          localStorage.removeItem("accessToken");
          window.location.reload();
          return;
        }
        console.log(err);
        toast.error(err?.response?.data?.error);
      }
    });
  };

  const onUpdateHandler = (values) => {
    startTransition(async () => {
      try {
        const updateUserPromise =  axios.put(
          `${import.meta.env.VITE_API_BOOKING}/api/user/profile/update`,
          {
            id: phoneDetail.id,
            faceIds: faceId ? [...(phoneDetail?.faceIds?.length > 0 ? phoneDetail?.faceIds : []), faceId] : null,
            fullName: values.fullName,
            gender: values?.gender,
            phone: values.phone,
            email: values.email,
            dob: values.dob ? values.dob.toISOString() : null,
            avatar: avatar ?? null,
          },
          {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          },
        );

        const updateFacePromise = axios.put(
          `${import.meta.env.VITE_API_URL}/api/faces/${faceId}`,
          {
            phone: values.phone,
            fullName: values.fullName,
            gender: values?.gender,
            email: values.email,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        await Promise.allSettled([updateUserPromise, updateFacePromise]);
        toast.success("Cập nhật thông tin tài khoản thành công");
        
        onOk({ faceId });
      } catch (err) {
        if (error.response.status === 401) {
          toast.error("Hết thời gian đăng nhập vui lòng đăng nhập lại.");
          localStorage.removeItem("accessToken");
          window.location.reload();
          return;
        }
        console.log(err);
        toast.error(err?.response?.data?.error);
      }
    });
  };

  return (
    <div className="register-form">
      <div className="navigation" onClick={() => onCancel()}>
        <ChevronLeft size={20} />
        Quay lại
      </div>
      <div className="register-form-avatar">
        {avatar ? (
          <img src={avatar} />
        ) : (
          <svg
            width="92"
            height="93"
            viewBox="0 0 92 93"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_279_2454)">
              <path
                d="M46.0001 0.61853C20.7701 0.61853 0.289062 21.1025 0.289062 46.3335C0.289062 71.5645 20.7731 92.0485 46.0001 92.0485C71.2301 92.0485 91.7151 71.5645 91.7151 46.3335C91.7151 21.1025 71.2311 0.61853 46.0001 0.61853ZM46.0001 3.47793C69.6841 3.47793 88.8551 22.6499 88.8551 46.3329C88.8551 70.0159 69.6831 89.1879 46.0001 89.1879C22.3171 89.1879 3.14506 70.0159 3.14506 46.3329C3.14506 22.6499 22.3171 3.47793 46.0001 3.47793ZM46.0001 16.5639C37.1329 16.5639 29.9181 23.8022 29.9181 32.6889C29.9181 41.5756 37.1329 48.8139 46.0001 48.8139C54.8673 48.8139 62.0821 41.5756 62.0821 32.6889C62.0821 23.8022 54.8673 16.5639 46.0001 16.5639ZM46.0001 19.4194C53.3165 19.4194 59.2271 25.3413 59.2271 32.6854C59.2271 40.0295 53.3209 45.9514 46.0001 45.9514C38.6837 45.9514 32.7771 40.0295 32.7771 32.6854C32.7771 25.3413 38.6833 19.4194 46.0001 19.4194ZM46.0001 52.0364C33.6371 52.0364 22.2701 58.8333 16.4181 69.7244C16.0509 70.4158 16.3087 71.2791 17.0001 71.6541C17.6915 72.0252 18.5548 71.7635 18.9298 71.0721C24.2853 61.1033 34.6838 54.8881 45.9998 54.8881C57.3158 54.8881 67.7028 61.1029 73.0588 71.0721C73.2385 71.408 73.5432 71.658 73.9104 71.7674C74.2736 71.8768 74.6643 71.8338 75.0002 71.6541C75.6916 71.2791 75.9494 70.4158 75.5822 69.7244C69.7345 58.8334 58.3631 52.0364 46.0001 52.0364Z"
                fill="url(#paint0_linear_279_2454)"
              />
            </g>
            <defs>
              <linearGradient
                id="paint0_linear_279_2454"
                x1="0.289063"
                y1="46.3335"
                x2="91.7151"
                y2="46.3335"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#639EB3" />
                <stop offset="1" stop-color="#BE9EAA" />
              </linearGradient>
              <clipPath id="clip0_279_2454">
                <rect
                  width="92"
                  height="92"
                  fill="white"
                  transform="translate(0 0.333374)"
                />
              </clipPath>
            </defs>
          </svg>
        )}
      </div>
      <Form layout="vertical" name="register" form={form}>
        <Form.Item
          name="phone"
          label="Số điện thoại"
          onBlur={() => onGetPhoneDetailHandler(form.getFieldValue("phone"))}
          rules={[
            {
              required: true,
              validateTrigger: "onBlur",
              validator: async (_, value) => {
                const schema = await PhoneSchema.safeParse(value);
                return schema.success
                  ? Promise.resolve()
                  : Promise.reject(schema.error.format()._errors[0]);
              },
            },
          ]}
        >
          <Input placeholder="Nhập số điện thoại" maxLength={10} />
        </Form.Item>
        {isPendingGetPhoneDetail && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "24px 0",
            }}
          >
            <Spin size="small" />
          </div>
        )}
        <Form.Item
          noStyle
          shouldUpdate={(prev, next) => prev?.phone !== next?.phone}
        >
          {({ getFieldValue }) => {
            const validPhone = PhoneSchema.safeParse(
              getFieldValue("phone"),
            ).success;
            
            return (
              <>
                <Form.Item
                  name="fullName"
                  label="Họ tên"
                  rules={[{ required: true }]}
                >
                  <Input placeholder="Nhập họ tên" disabled={!validPhone} />
                </Form.Item>
                <Form.Item
                  name="dob"
                  label="Ngày sinh"
                  rules={[{ required: true }]}
                >
                  <DatePicker
                    format={{ format: "DD/MM/YYYY", type: "mark" }}
                    style={{ width: "100%" }}
                    placeholder="Chọn ngày sinh"
                    disabled={!validPhone}
                  />
                </Form.Item>
                <Form.Item
                  name="gender"
                  label="Giới tính"
                  rules={[{ required: true }]}
                >
                  <Select
                    placeholder="Chọn giới tính"
                    disabled={!validPhone}
                    options={[
                      { label: "Nam", value: "MALE" },
                      { label: "Nữ", value: "FEMALE" },
                    ]}
                  />
                </Form.Item>
                <Form.Item name="email" label="Email">
                  <Input placeholder="Nhập email" disabled={!validPhone} />
                </Form.Item>
                {phoneDetail && (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr",
                    }}
                  >
                    <Button
                      type="primary"
                      disabled={isPending}
                      loading={isPending}
                      onClick={() =>
                        form
                          .validateFields()
                          .then(
                            phoneDetail?.phone
                              ? onUpdateHandler
                              : onRegisterHandler,
                          )
                      }
                    >
                      {phoneDetail?.phone ? "Cập nhật" : "Đăng kí"}
                    </Button>
                  </div>
                )}
              </>
            );
          }}
        </Form.Item>
      </Form>
    </div>
  );
};
